import React from 'react';
import fire from '../firebase/firebase';
import binary from '../assets/img/binary-roots-narrow.jpg';

class Solutions extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        caseStudiesSummary: null,
        caseStudiesMain: null
       };
    }

    componentDidMount() {

      let caseStudiesSummary = fire.database().ref('casestudies-summary');
      let caseStudiesMain = fire.database().ref('casestudies-main');

      caseStudiesSummary.on('value', snapshot => {
        this.setState({caseStudiesSummary: snapshot.val()});
      });
      caseStudiesMain.on('value', snapshot => {
        this.setState({caseStudiesMain: snapshot.val()});
      });
    }

  render() {
    return (
      <div>
        <div className="app-main-container">
          <div className="app-content__heading page-heading-container">
            <div className="app-header-container page-heading">
            <h1 className="heavy">Case Studies<span className="eitx-orange">.</span></h1>
            <p>{this.state.caseStudiesSummary}</p>
            </div>
          </div>
        
          <div className="app-content main-content">
            <div dangerouslySetInnerHTML={{__html: this.state.caseStudiesMain}} className="app-content--two-thirds-summary"></div>
            <div className="app-content--one-third-right app-content--one-third-right__image">
              <img className="large-img" src={binary} alt="solutions" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Solutions;



// WEBPACK FOOTER //
// ./src/pages/casestudies.js